import { Group, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

export const LegalLinks = () => {
  return (
    <Group justify="center">
      <Text size="sm" component={Link} to="/privacy">
        Privacy
      </Text>
      <Text size="sm" component={Link} to="/terms">
        Terms of Use
      </Text>
    </Group>
  );
};
